import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatBranchType, formatQualificationType } from "@/utils/formatters";
import { GraduationCap, Building2, Trophy } from "lucide-react";
import type { Tables } from "@/integrations/supabase/types";

type Candidate = Tables<"candidates">;

interface CandidateEducationInfoProps {
  candidate: Candidate;
}

export function CandidateEducationInfo({
  candidate,
}: CandidateEducationInfoProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <GraduationCap className="h-5 w-5" />
          Education Information
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 gap-4">
          {candidate.qualification && (
            <div>
              <span className="font-medium">Qualification:</span>
              <span className="ml-2">
                {formatQualificationType(candidate.qualification)}
              </span>
            </div>
          )}

          {candidate.branch && (
            <div>
              <span className="font-medium">Branch:</span>
              <span className="ml-2">{formatBranchType(candidate.branch)}</span>
            </div>
          )}

          {candidate.enrollment_number && (
            <div>
              <span className="font-medium">Enrollment Number:</span>
              <span className="ml-2">{candidate.enrollment_number}</span>
            </div>
          )}

          {candidate.college_university && (
            <div className="flex items-center gap-2">
              <Building2 className="h-4 w-4 text-muted-foreground" />
              <span className="font-medium">College:</span>
              <span>{candidate.college_university}</span>
            </div>
          )}

          {candidate.cgpa && (
            <div className="flex items-center gap-2">
              <Trophy className="h-4 w-4 text-muted-foreground" />
              <span className="font-medium">CGPA:</span>
              <span>{candidate.cgpa}</span>
            </div>
          )}

          {candidate.latest_semester_score && (
            <div>
              <span className="font-medium">Latest Semester Score:</span>
              <span className="ml-2">{candidate.latest_semester_score}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
